<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-container grid-list-sm fluid>
                    <v-layout row wrap>
                        <v-flex
                            v-for="(postImage, i) in postImagesToRender"
                            :key="postImage.url"
                            v-bind:class="'xs'+12/imageViewPartitions"
                            d-flex>
                            <v-card flat tile class="d-flex">
                                <v-img :src="postImage.url" :lazy-src="postImage.url" class="grey lighten-12">
                                    <v-layout
                                        slot="placeholder"
                                        fill-height
                                        align-center
                                        justify-center
                                        ma-0>
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-layout>
                                    <div v-if="hiddenImages.length && i === postImagesToRender.length - 1" class="image_text">{{hiddenImages.length}}+</div>
                                </v-img>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: 'ActivityImageGrid',
        props: {
            postImages: {
                type: Array,
                imageViewPartitions: 1,
                required: true,
            },
        },
        created() {
            if (this.postImages.length > 4) {
                this.postImagesToRender = this.postImages.slice(0, 4);
                this.hiddenImages = this.postImages.slice(4, this.postImages.length);
                this.imageViewPartitions = 2;
            } else if (this.postImages.length > 1) {
                this.postImagesToRender = this.postImages.slice(0, 2);
                this.hiddenImages = this.postImages.slice(2, this.postImages.length);
                this.imageViewPartitions = 2;
            } else {
                this.postImagesToRender = this.postImages;
                this.imageViewPartitions = 1;
            }
        },
        data() {
            return {
                postImagesToRender: [],
                hiddenImages: [],
            };
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';

    .post_image {
        object-fit: contain;
        width: 100%;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        display: block;
    }

    .image_text {
        text-align: center;
        color: $white;
        font-size: 2.5em;
        position: absolute;
        top: 40%;
        left: 40%;
    }
</style>
